export default __webpack_public_path__ + "static/media/Public Transit.db639466.svg";